export const urls = {
  GET_SLEDECI_BROJ:
    'DokRNServisni/vrati_sledeci_br_dok_za_radni_nalog_servisni',
  GET_KUPCE_DATA: 'Combo/vrati_kupce_combo',
  GET_MASINE_ZA_KUPCA: 'Combo/vrati_masine_za_kupca',
  INSERT_RADNI_NALOG: 'DokRNServisni/unos_dok_rn_servisni',
  UPDATE_RADNI_NALOG: 'DokRNServisni/izmena_dok_rn_servisni',
  DELETE_RADNI_NALOG: 'DokRNServisni/brisanje_dok_rn_servisni',
  GET_SERVISNI_ZAHTEV_ZA_ID:
    'DokServisniZahtevi/vrati_dok_servisni_zahtev_za_id',
  VRATI_PREGLED_SERVISA: 'DokRNServisni/dok_rn_servisni_pregled',
  GET_ZAPOSLENI_COMBO: 'Combo/vrati_zaposlene_combo',
  DODELI_ZAPOSLENIMA: 'DokRNServisni/RNS_dodeljeni_zaposleni',
  GET_ZAPOSLENI_ZA_RN: 'DokRNServisni/RNS_vrati_zaposlene_na_rn',
};
